// extracted by mini-css-extract-plugin
export var cornerLeftTop = "styles-module--cornerLeftTop--1neQP";
export var cornerLeftBottom = "styles-module--cornerLeftBottom--1Wv1W";
export var cornerRightTop = "styles-module--cornerRightTop--3S6gB";
export var cornerRightBottom = "styles-module--cornerRightBottom--2Xnzq";
export var cornerHidden = "styles-module--cornerHidden--1luz8";